var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "payindex" } },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("pagehead", {
            ref: "pagehead",
            attrs: { userInfo: _vm.userInfo || {} }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fc-pad-b-sm fc-pad-lr fc-space-between fc-mar-t" },
            [
              _c("div", { staticClass: "tab" }, [
                _c(
                  "span",
                  {
                    staticClass: "fc-text-sm fc-color-gray tab_item",
                    class: { active: _vm.tabType == 1 },
                    on: {
                      click: function($event) {
                        _vm.tabType = 1
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("m.payforType")))]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "splitLine" }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "fc-text-sm fc-color-gray tab_item",
                    class: { active: _vm.tabType == 2 },
                    on: {
                      click: function($event) {
                        _vm.tabType = 2
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("m.reseller")))]
                )
              ]),
              _vm._v(" "),
              _vm.selCountryInfo.content && _vm.tabType == 1
                ? _c(
                    "div",
                    {
                      staticClass: "select-local",
                      on: {
                        click: function($event) {
                          _vm.showcountryPicker = true
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: { src: require("../assets/img/cz_location.png") }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.selCountryInfo.content))])
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm.tabType == 2
            ? _c(
                "div",
                [_c("sellers", { attrs: { country: _vm.selCountryInfo } })],
                1
              )
            : _c(
                "div",
                [
                  _vm.payStyleArr
                    ? _c(
                        "van-collapse",
                        {
                          staticClass: "payStyleCon",
                          attrs: { accordion: "" },
                          on: { change: _vm.changePayType },
                          model: {
                            value: _vm.activePayIndex,
                            callback: function($$v) {
                              _vm.activePayIndex = $$v
                            },
                            expression: "activePayIndex"
                          }
                        },
                        _vm._l(_vm.payStyleArr, function(item, index) {
                          return _c(
                            "van-collapse-item",
                            {
                              key: "pay" + index,
                              attrs: { name: index },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function() {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "fc-flex fc-flex-vcenter"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "payStyleIcon" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src:
                                                      item.rechargePayType
                                                        .payTypeImg
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "fc-flex1 fc-text-bigabit"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.rechargePayType
                                                      .payTypeShowName
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(" "),
                              item.rechargePayType.payTypeShowName &&
                              item.rechargePayType.payTypeShowName.toLowerCase() ==
                                "razer gold pin"
                                ? _c("div", { staticClass: "payTiptxt" }, [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("m.recharge_tip"))
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(item.rechargeNormList, function(
                                son,
                                index
                              ) {
                                return _c("buy-item", {
                                  key: "paymoney" + index,
                                  attrs: {
                                    payType: item,
                                    normInfo: son,
                                    selCountryInfo: _vm.selCountryInfo,
                                    userInfo: _vm.userInfo || {},
                                    domainCountry: _vm.domainCountry,
                                    from: _vm.from
                                  }
                                })
                              })
                            ],
                            2
                          )
                        }),
                        1
                      )
                    : _c("div", { staticClass: "nodataImg" }, [
                        _c("img", {
                          attrs: {
                            src: require("../assets/img/nodata.png"),
                            alt: ""
                          }
                        })
                      ])
                ],
                1
              ),
          _vm._v(" "),
          _vm.tabType == 1 && !_vm.userInfo.userId && _vm.isInBuzzCast
            ? _c("p", {
                staticClass: "fc-notice",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("m.buy-notice-a", { msg: _vm.curHost })
                  )
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.tabType == 1 && !_vm.userInfo.userId && _vm.isInBuzzCast
        ? _c("ask")
        : _vm._e(),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          style: { width: "6rem", "max-width": "370px", "margin-left": "0" },
          attrs: { closeable: "", "overlay-class": "fcId_mask" },
          model: {
            value: _vm.showIdDesc,
            callback: function($$v) {
              _vm.showIdDesc = $$v
            },
            expression: "showIdDesc"
          }
        },
        [
          _c("div", { staticClass: "fc-text-center fc-pad-tb" }, [
            _c(
              "p",
              { staticClass: "fc-text-center fc-text-center fc-text-usual" },
              [_vm._v(_vm._s(_vm.$t("m.openAPP")))]
            ),
            _vm._v(" "),
            _c("img", {
              attrs: {
                src: require("../assets/img/findID.png"),
                width: "94%",
                alt: ""
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { round: "", position: "bottom" },
          on: { close: _vm.closeHandle },
          model: {
            value: _vm.showcountryPicker,
            callback: function($$v) {
              _vm.showcountryPicker = $$v
            },
            expression: "showcountryPicker"
          }
        },
        [
          _c("van-picker", {
            attrs: {
              "show-toolbar": "",
              "default-index": _vm.currentCountryIndex,
              loading: _vm.countryLoading,
              "confirm-button-text": _vm.$t("m.trueText"),
              "cancel-button-text": _vm.$t("m.falseText"),
              columns: _vm.countryArr,
              "value-key": "content",
              "default-index": "0"
            },
            on: {
              cancel: function($event) {
                return _vm.closeHandle()
              },
              confirm: _vm.selCountryConfirm
            },
            scopedSlots: _vm._u([
              {
                key: "columns-top",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "searchBox" },
                      [
                        _c("van-field", {
                          staticClass: "inputContent",
                          attrs: { placeholder: _vm.$t("m.placecommen") },
                          on: { input: _vm.searchValueChange },
                          scopedSlots: _vm._u([
                            {
                              key: "left-icon",
                              fn: function() {
                                return [
                                  _c("img", {
                                    staticStyle: {
                                      width: "14px",
                                      display: "flex",
                                      "justify-content": "center",
                                      "align-items": "center"
                                    },
                                    attrs: {
                                      src: require("../assets/img/icon_search.png")
                                    }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ]),
                          model: {
                            value: _vm.searchValue,
                            callback: function($$v) {
                              _vm.searchValue = $$v
                            },
                            expression: "searchValue"
                          }
                        })
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _vm.countryShow
            ? _c("div", { staticClass: "countryImg" }, [
                _c("img", {
                  attrs: { src: require("../assets/img/country.png"), alt: "" }
                })
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.isShowWechatPop
        ? _c("van-overlay", { attrs: { show: _vm.isShowWechatPop } }, [
            _c(
              "div",
              {
                staticClass: "van-dialog",
                staticStyle: { width: "76%" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              },
              [
                _c("div", { staticClass: "wechatPaycon" }, [
                  _c("div", [_vm._v(_vm._s(_vm.$t("m.wxPay")))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "van-hairline--top fc-color-main",
                      on: {
                        click: function($event) {
                          return _vm.completePay(1)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("m.Completed")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "van-hairline--top",
                      on: {
                        click: function($event) {
                          return _vm.completePay(2)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("m.failedPay")))]
                  )
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("guide", {
        attrs: {
          show: _vm.isShowGuide,
          top: _vm.guildeTop,
          selCountryInfo: _vm.selCountryInfo
        },
        on: {
          close: function($event) {
            _vm.isShowGuide = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57509004", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57509004","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index.vue
// module id = null
// module chunks = 